export type ChargebacksTab = "refunds" | "disputes";

export const DEFAULT_CHARGEBACKS_TAB: ChargebacksTab = "refunds";

export function parseChargebacksTab(value: string | null): ChargebacksTab {
  return value === "disputes" ? "disputes" : DEFAULT_CHARGEBACKS_TAB;
}
